export default __webpack_public_path__ + "static/media/moon.20a8272b.svg";